import { sr } from "date-fns/locale";

export const HomePlatformList = [
  {
    name: "All",
  },
  {
    name: "hot",
  },
  {
    categoryType: "casino",
    gameType: 2,
    vendor: "EVOLUTION",
    name: "EVO",
    src: "/assets/Platform/provider-evo.png",
    alt: "provider-awcv2_evolution",
  },
  {
    categoryType: "casino",
    gameType: 2,
    vendor: "SEXYBCRT",
    name: "SEXY",
    src: "/assets/Platform/provider-awcmsexy.png",
    alt: "provider-awcmsexy",
  },
  {
    categoryType: "slots",
    gameType: 2,
    vendor: "PP",
    name: "PP",
    src: "/assets/Platform/provider-awcmpp.png",
    alt: "provider-awcmpp",
  },
  {
    categoryType: "slots",
    gameType: 2,
    vendor: "PLAYTECH",
    name: "PLAYTECH",
    src: "/assets/Platform/provider-awcmpt.png",
    alt: "provider-awcmpt",
  },
  {
    categoryType: "slots",

    vendor: "KINGMAKER",
    name: "KM",
    src: "/assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcmkm",
  },
  {
    categoryType: "slots",

    vendor: "JILI",
    name: "JILI",
    src: "/assets/Platform/provider-awcmjili.png",
    alt: "provider-awcmjili",
  },
  {
    categoryType: "slots",

    vendor: "PG",
    name: "PG",
    src: "/assets/Platform/provider-awcv2_pg.png",
    alt: "provider-awcv2_pg",
  },
  {
    categoryType: "slots",

    vendor: "JDB",
    name: "JDB",
    src: "/assets/Platform/jdb.png",
  },
  {
    categoryType: "slots",

    vendor: "FC",
    name: "FC",
    src: "/assets/Platform/provider-awcmfc.png",
    alt: "provider-awcmfc",
  },
  {
    categoryType: "slots",

    vendor: "RT",
    name: "RT",
    src: "/assets/Platform/provider-awcmrt.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcmrt",
  },
  {
    categoryType: "slots",
    gameType: 8,
    vendor: "SPADE",
    name: "SPADE",
    src: "/assets/Platform/provider-awcmsg.png",
    alt: "provider-awcmsg",
  },
  {
    categoryType: "slots",

    vendor: "NETENT",
    name: "NETENT",
    src: "/assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
    alt: "provider-netent",
  },
  {
    categoryType: "casino",
    gameType: 2,
    vendor: "VIACASINO",
    name: "VIA",
    src: "/assets/Platform/provider-awcmvia.png",
    alt: "provider-awcmvia",
  },

  {
    categoryType: "casino",
    gameType: 2,
    vendor: "DREAMGAMING",
    name: "DG",
    src: "/assets/Platform/provider-awcmdg.png",
    alt: "provider-awcmdg",
  },
  {
    categoryType: "casino",
    gameType: 2,
    vendor: "HOTROAD",
    name: "HotRoad",
    src: "/assets/Platform/provider-awcmhotroad.png",
    alt: "provider-awcv2_hotroad",
  },

  {
    categoryType: "casino",
    gameType: 2,
    vendor: "CREEDROOMZ",
    name: "CreedRoomz",
    src: "/assets/Platform/provider-awcv2_creedroomz.png",
    alt: "provider-awcv2_creedroomz",
  },
  {
    categoryType: "casino",
    gameType: 2,
    vendor: "WINFINITY",
    name: "WINFINITY",
    src: "/assets/Platform/provider-awcv2_winfinity.png",
    alt: "provider-awcv2_winfinity",
  },

  {
    categoryType: "slots",

    vendor: "FASTSPIN",
    name: "FASTSPIN",
    src: "/assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcmfastspin",
  },
  {
    categoryType: "slots",

    vendor: "YESBINGO",
    name: "YELLOW BAT",
    src: "/assets/Platform/provider-awcv2_yesbingo.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcv2_yesbingo",
  },
  {
    categoryType: "slots",

    vendor: "BTG",
    name: "BTG",
    src: "/assets/Platform/provider-awcv2_btg.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcv2_btg",
  },
  {
    categoryType: "slots",

    vendor: "NLC",
    name: "NLC",
    src: "/assets/Platform/provider-awcv2_nlc.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcv2_nlc",
  },
  {
    categoryType: "slots",

    vendor: "DRAGOONSOFT",
    name: "Dragoonsoft",
    src: "/assets/Platform/provider-awcv2_dragoonsoft.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcv2_dragoonsoft",
  },

  {
    categoryType: "slots",

    vendor: "PLAY8",
    name: "P8",
    src: "/assets/Platform/provider-awcmp8.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcmp8",
  },
  {
    categoryType: "slots",

    vendor: "Joker",
    name: "Joker",
    src: "/assets/Platform/provider-joker.png?v=1772072361392&source=mcdsrc",
    alt: "provider-joker",
  },
  {
    categoryType: "slots",

    vendor: "PLAYNGO",
    name: "PNG",
    src: "/assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
    alt: "provider-playngo",
  },

  {
    categoryType: "slots",

    vendor: "CG",
    name: "CG",
    src: "/assets/Platform/provider-awcmcg.png",
    alt: "provider-awcmcg",
  },
  {
    categoryType: "slots",

    vendor: "YL",
    name: "YL",
    src: "/assets/Platform/yl.png",
  },
  {
    categoryType: "slots",

    vendor: "RELAX",
    name: "RELAX",
    src: "/assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcv2_relax",
  },
  {
    categoryType: "slots",

    vendor: "OCTOPLAY",
    name: "OCTOPLAY",
    src: "/assets/Platform/provider-awcv2_octoplay.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcv2_octoplay",
  },
  {
    categoryType: "slots",

    vendor: "ACEWIN",
    name: "ACEWiN",
    src: "/assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcv2_acewin",
  },
  {
    categoryType: "slots",

    vendor: "HACKSAW",
    name: "HACKSAW",
    src: "/assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcv2_hacksaw",
  },
  {
    categoryType: "slots",

    vendor: "JJ",
    name: "JJ",
    src: "/assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcv2_jj",
  },
  {
    categoryType: "slots",

    vendor: "YGGDRASIL",
    name: "YGGDRASIL",
    src: "/assets/Platform/provider-awcv2_yggdrasil.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcv2_yggdrasil",
  },
  {
    categoryType: "table",
    gameType: 8192,
    vendor: "SPRIBE",
    name: "JDBASPRIBE",
    src: "/assets/Platform/provider-jdbaspribe.png?v=1772072361392&source=mcdsrc",
    alt: "provider-jdbaspribe",
  },
  {
    categoryType: "slots",
    gameType: 8192,
    vendor: "CRASH88",
    name: "CRASH88",
    src: "/assets/Platform/provider-awcv2_crash88.png?v=1772072361392&source=mcdsrc",
    alt: "provider-awcv2_crash88",
  },
];

export const HomeTabData = {
  hot: [
    {
      vendorCode: "JILI",
      name: "Aviator",
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-001",
      src: "/assets/HotGames/aviator.webp",
    },
    {
      vendorCode: "PG",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-058",
      name: "Treasures of Aztec",
      src: "/assets/HotGames/darkIcon (10).webp",
    },
    {
      name: "Penalty Shootout",
      img: "/assets/Old/PP-EGAME-002.webp",
      platForm: "PP",
      type: "slots",
      gameType: "SLOT",
      casinoType: "PP-SLOT-002",
      platFormCode: "PP",
    },
    {
      name: "Gates of Olympus Super Scatter",
      img: "/assets/Slot/PP-SLOT-562.webp?v=1755572377209",
      platForm: "PP",
      type: "slots",
      gameType: "SLOT",
      casinoType: "PP-SLOT-562",
      platFormCode: "PP",
    },

    {
      name: "Wounderland",
      img: "/assets/Casino/GAME-SHOW-16.webp",
      platForm: "PLAYTECH",
      type: "CASINO",
      gameType: "LIVE",
      casinoType: "PLAYTECH-LIVE-138",
      platFormCode: "PLAYTECH",
    },
    {
      name: "Mega Sic Bo",
      img: "/assets/Casino/PP-LIVE-025.webp?v=1751418030744",
      platForm: "PP",
      type: "Casino",
      gameType: "LIVE",
      casinoType: "PP-LIVE-025",
      platFormCode: "PP",
    },
    {
      name: "Mega Wheel",
      img: "/assets/Casino/PP-LIVE-038.webp?v=1751418030744",
      platForm: "PP",
      type: "Casino",
      gameType: "LIVE",
      casinoType: "PP-LIVE-038",
      platFormCode: "PP",
    },
    {
      name: "Mega Roulette",
      img: "/assets/Casino/PP-LIVE-039.webp?v=1751418030744",
      platForm: "PP",
      type: "Casino",
      gameType: "LIVE",
      casinoType: "PP-LIVE-039",
      platFormCode: "PP",
    },
    {
      name: "Mega Baccarat",
      img: "/assets/Casino/PP-LIVE-061.Mega-Baccarat.webp?v=1764408470795",
      platForm: "PP",
      type: "Casino",
      gameType: "LIVE",
      casinoType: "PP-LIVE-061",
      platFormCode: "PP",
    },
    {
      name: "Dragon Tiger",
      src: "/assets/HotGames/pdt.webp",
      platForm: "PP",
      type: "Casino",
      gameType: "LIVE",
      casinoType: "PP-LIVE-042",
      platFormCode: "PP",
    },
    {
      name: "Hi-lo",
      img: "/assets/Casino/GAME-SHOW-30.webp",
      platForm: "PLAYTECH",
      type: "CASINO",
      gameType: "LIVE",
      casinoType: "PLAYTECH-LIVE-014",
      platFormCode: "PLAYTECH",
    },
    {
      src: "/assets/HotGames/playtech-teen-patti.webp",
      name: "Teen Patti Live",
      platForm: "PLAYTECH",
      gameType: "LIVE",
      casinoType: "PLAYTECH-LIVE-087",
      platFormCode: "PLAYTECH",
    },
    {
      vendorCode: "JILI",
      name: "Super Ace",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-027",
      src: "/assets/HotGames/darkIcon (12).webp",
    },
    {
      src: "/assets/HotGames/JILI-SLOT-031.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-031",
      name: "Boxing King",
    },
    {
      vendorCode: "JILI",
      name: "Fortune Gems 500",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-043",
      src: "/assets/HotGames/darkIcon (7).webp",
    },
    {
      vendorCode: "JILI",
      name: "Super Ace Deluxe",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-102",
      src: "/assets/HotGames/darkIcon (13).webp",
    },

    {
      src: "/assets/HotGames/JILI-SLOT-096.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-096",
      name: "Fortune Gems 3",
    },

    {
      src: "/assets/HotGames/JILI-SLOT-076.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-076",
      name: "Fortune Gems 2",
    },

    {
      src: "/assets/HotGames/JILI-SLOT-043.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-043",
      name: "Fortune Gems",
    },
    {
      vendorCode: "JILI",
      name: "Money Coming",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-029",
      src: "/assets/HotGames/darkIcon (8).webp",
    },
    {
      vendorCode: "FC",
      name: "NCVIP Super Elements",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-033",
      src: "/assets/HotGames/darkIcon.webp",
    },
    {
      gameType: 8192,
      vendorCode: "JILI",
      name: "Crash Aviator",
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-001",
      src: "/assets/HotGames/darkIcon (6).webp",
    },

    {
      src: "/assets/HotGames/FC-SLOT-028.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-028",
      name: "GOLDEN GENIE",
    },

    {
      src: "/assets/HotGames/YESBINGO-SLOT-037.webp",
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-037",
      name: "Pirate Legends",
    },
    {
      gameType: 2,
      vendorCode: "EVOLUTION",
      name: "Crazy Time",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-006",
      src: "/assets/HotGames/darkIcon (19).webp",
    },
    {
      gameType: 2,
      vendorCode: "SEXYBCRT",
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-001",
      name: "Baccarat Classic",
      src: "/assets/HotGames/darkIcon (20).webp",
    },
    {
      vendorCode: "PG",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-105",
      name: "Wild Bounty Showdown",
      src: "/assets/HotGames/darkIcon (9).webp",
    },
    {
      vendorCode: "JDB",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-127",
      name: "Magic Ace WILD LOCK",
      src: "/assets/HotGames/darkIcon (15).webp",
    },
    {
      vendorCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-598",
      name: "Fortune Ace Super Scatter",
      platFormCode: "PP",
      src: "/assets/HotGames/darkIcon (5).webp",
    },
    {
      gameType: 2,
      vendorCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-188",
      name: "Money Time",
      platFormCode: "PP",
      src: "/assets/HotGames/darkIcon (21).webp",
    },

    {
      src: "/assets/HotGames/JDB-SLOT-123.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-123",
      name: "Piggy Bank",
    },

    // {
    //   vendorCode: "PP",
    //   gameType: "SLOT",
    //   platFormCode: "PP",
    //   casinoType: "PP-SLOT-411",
    //   name: "NCVIP Gates of Olympus 1000",
    //   src: "/assets/HotGames/darkIcon (1).webp",
    // },
    // {
    //   vendorCode: "JILI",
    //   name: "Lucky Jaguar 500",
    //   platFormCode: "JILI",
    //   gameType: "SLOT",
    //   casinoType: "JILI-SLOT-115",
    //   src: "/assets/HotGames/darkIcon (2).webp",
    // },
    // {
    //   gameType: 2,
    //   vendorCode: "PP",
    //   gameType: "LIVE",
    //   casinoType: "PP-LIVE-190",
    //   name: "24D Spin",
    //   platFormCode: "PP",
    //   src: "/assets/HotGames/darkIcon (3).webp",
    // },
    // {
    //   vendorCode: "JILI",
    //   platFormCode: "JILI",
    //   gameType: "SLOT",
    //   casinoType: "JILI-SLOT-142",
    //   name: "Super Ace Speed Exclusive",
    //   src: "/assets/HotGames/darkIcon (4).webp",
    // },

    // {
    //   vendorCode: "PG",
    //   name: "Anubis Wrath",
    //   platFormCode: "PG",
    //   gameType: "SLOT",
    //   casinoType: "PG-SLOT-138",
    //   src: "/assets/HotGames/darkIcon (11).webp",
    // },

    // {
    //   vendorCode: "JILI",
    //   name: "Circus Joker 4096",
    //   platFormCode: "JILI",
    //   gameType: "SLOT",
    //   casinoType: "JILI-SLOT-136",
    //   src: "/assets/HotGames/darkIcon (14).webp",
    // },

    // {
    //   vendorCode: "FC",
    //   platFormCode: "FC",
    //   gameType: "SLOT",
    //   casinoType: "FC-SLOT-028",
    //   name: "GOLDEN GENIE",
    //   src: "/assets/HotGames/darkIcon (16).webp",
    // },
    // {
    //   gameType: 1024,
    //   vendorCode: "JILI",
    //   name: "Frog Dash",
    //   platFormCode: "JILI",
    //   gameType: "TABLE",
    //   casinoType: "JILI-TABLE-088",
    //   src: "/assets/HotGames/darkIcon (17).webp",
    // },
    // {
    //   gameType: 1024,
    //   vendorCode: "JILI",
    //   platFormCode: "JILI",
    //   gameType: "TABLE",
    //   casinoType: "JILI-TABLE-082",
    //   name: "Chicken Dash 10000",
    //   src: "/assets/HotGames/darkIcon (18).webp",
    // },
  ],
  sports: [
    {
      gameType: 4,
      vendorCode: "CRICKET",
      name: "9wickets",
      src: "/assets/Platform/icon-9w-cricket.png",
      alt: "icon-9w-cricket",
    },
    {
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "Velki",
      src: "/assets/Icon/velki-favicon.ico",
      alt: "icon-cricket",
    },
    {
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "Exchange",
      src: "/assets/Platform/icon-cricket.svg",
      alt: "icon-cricket",
    },
  ],
  casino: [
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "EVOLUTION",
      name: "EVO",
      src: "/assets/Platform/provider-evo.png",
      alt: "provider-awcv2_evolution",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "SEXYBCRT",
      name: "SEXY",
      src: "/assets/Platform/provider-awcmsexy.png",
      alt: "provider-awcmsexy",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "PP",
      name: "PP",
      src: "/assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },

    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "BG",
      name: "BG",
      src: "/assets/Platform/provider-bg.png",
      alt: "provider-awcmpp",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "PLAYTECH",
      name: "PLAYTECH",
      src: "/assets/Platform/provider-awcmpt.png",
      alt: "provider-awcmpt",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "DREAMGAMING",
      name: "DG",
      src: "/assets/Platform/provider-awcmdg.png",
      alt: "provider-awcmdg",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "HOTROAD",
      name: "HotRoad",
      src: "/assets/Platform/provider-awcmhotroad.png",
      alt: "provider-awcv2_hotroad",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "VIACASINO",
      name: "VIA",
      src: "/assets/Platform/provider-awcmvia.png",
      alt: "provider-awcmvia",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "CREEDROOMZ",
      name: "CreedRoomz",
      src: "/assets/Platform/provider-awcv2_creedroomz.png",
      alt: "provider-awcv2_creedroomz",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "WINFINITY",
      name: "WINFINITY",
      src: "/assets/Platform/provider-awcv2_winfinity.png",
      alt: "provider-awcv2_winfinity",
    },
  ],
  slots: [
    {
      categoryType: "VENDOR",

      vendor: "JILI",
      name: "JILI",
      src: "/assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",

      vendor: "PG",
      name: "PG",
      src: "/assets/Platform/provider-awcv2_pg.png",
      alt: "provider-awcv2_pg",
    },
    {
      categoryType: "VENDOR",

      vendor: "JDB",
      name: "JDB",
      src: "/assets/Platform/jdb.png",
    },
    {
      categoryType: "VENDOR",

      vendor: "FC",
      name: "FC",
      src: "/assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },
    {
      categoryType: "VENDOR",

      vendor: "SPADE",
      name: "SG",
      src: "/assets/Platform/provider-awcmsg.png",
      alt: "provider-awcmsg",
    },
    {
      categoryType: "VENDOR",

      vendor: "FASTSPIN",
      name: "FASTSPIN",
      src: "/assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmfastspin",
    },
    {
      categoryType: "VENDOR",

      vendor: "PP",
      name: "PP",
      src: "/assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },
    {
      categoryType: "VENDOR",

      vendor: "YESBINGO",
      name: "YELLOW BAT",
      src: "/assets/Platform/provider-awcv2_yesbingo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yesbingo",
    },
    {
      categoryType: "VENDOR",

      vendor: "BTG",
      name: "BTG",
      src: "/assets/Platform/provider-awcv2_btg.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_btg",
    },
    {
      categoryType: "VENDOR",

      vendor: "NLC",
      name: "NLC",
      src: "/assets/Platform/provider-awcv2_nlc.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_nlc",
    },
    {
      categoryType: "VENDOR",

      vendor: "DRAGOONSOFT",
      name: "Dragoonsoft",
      src: "/assets/Platform/provider-awcv2_dragoonsoft.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_dragoonsoft",
    },
    {
      categoryType: "VENDOR",

      vendor: "RT",
      name: "RT",
      src: "/assets/Platform/provider-awcmrt.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmrt",
    },
    {
      categoryType: "VENDOR",

      vendor: "PLAYTECH",
      name: "PLAYTECH",
      src: "/assets/Platform/provider-awcmpt.png",
      alt: "provider-awcmpt",
    },
    {
      categoryType: "VENDOR",

      vendor: "NETENT",
      name: "NETENT",
      src: "/assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
      alt: "provider-netent",
    },
    {
      categoryType: "VENDOR",

      vendor: "PLAY8",
      name: "P8",
      src: "/assets/Platform/provider-awcmp8.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmp8",
    },
    {
      categoryType: "VENDOR",

      vendor: "Joker",
      name: "Joker",
      src: "/assets/Platform/provider-joker.png?v=1772072361392&source=mcdsrc",
      alt: "provider-joker",
    },
    {
      categoryType: "VENDOR",

      vendor: "PLAYNGO",
      name: "PNG",
      src: "/assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-playngo",
    },
    {
      categoryType: "VENDOR",

      vendor: "KINGMAKER",
      name: "KM",
      src: "/assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },
    {
      categoryType: "VENDOR",

      vendor: "CG",
      name: "CG",
      src: "/assets/Platform/provider-awcmcg.png",
      alt: "provider-awcmcg",
    },
    {
      categoryType: "VENDOR",

      vendor: "YL",
      name: "YL",
      src: "/assets/Platform/yl.png",
    },
    {
      categoryType: "VENDOR",

      vendor: "RELAX",
      name: "RELAX",
      src: "/assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    {
      categoryType: "VENDOR",

      vendor: "OCTOPLAY",
      name: "OCTOPLAY",
      src: "/assets/Platform/provider-awcv2_octoplay.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_octoplay",
    },
    {
      categoryType: "VENDOR",

      vendor: "ACEWIN",
      name: "ACEWiN",
      src: "/assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_acewin",
    },
    {
      categoryType: "VENDOR",

      vendor: "HACKSAW",
      name: "HACKSAW",
      src: "/assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_hacksaw",
    },
    {
      categoryType: "VENDOR",

      vendor: "JJ",
      name: "JJ",
      src: "/assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_jj",
    },

    {
      categoryType: "VENDOR",

      vendor: "YGGDRASIL",
      name: "YGGDRASIL",
      src: "/assets/Platform/provider-awcv2_yggdrasil.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yggdrasil",
    },
  ],
  crash: [
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "SPRIBE",
      name: "JDBASPRIBE",
      src: "/assets/Platform/provider-jdbaspribe.png?v=1772072361392&source=mcdsrc",
      alt: "provider-jdbaspribe",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "JILI",
      name: "JILI",
      src: "/assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "JDB",
      name: "JDB",
      src: "/assets/Platform/jdb.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "FC",
      name: "FC",
      src: "/assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "PP",
      name: "PP",
      src: "/assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "KINGMAKER",
      name: "KM",
      src: "/assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },

    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "CG",
      name: "CG",
      src: "/assets/Platform/provider-awcmcg.png",
      alt: "provider-awcmcg",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "YL",
      name: "YL",
      src: "/assets/Platform/darkIcon.png",
    },

    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "RELAX",
      name: "RELAX",
      src: "/assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "CRASH88",
      name: "CRASH88",
      src: "/assets/Platform/provider-awcv2_crash88.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_crash88",
    },
  ],
  table: [
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "JILI",
      name: "JILI",
      src: "/assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "KINGMAKER",
      name: "KM",
      src: "/assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },

    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "SPRIBE",
      name: "JDBASPRIBE",
      src: "/assets/Platform/provider-jdbaspribe.png?v=1772072361392&source=mcdsrc",
      alt: "provider-jdbaspribe",
    },

    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "NETENT",
      name: "NETENT",
      src: "/assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
      alt: "provider-netent",
    },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "PLAYTECH",
      name: "PLAYTECH",
      src: "/assets/Platform/provider-awcmpt.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmpt",
    },
    // {
    //   categoryType: "VENDOR",
    //   gameType: 256,
    //   vendor: "PLAYNGO",
    //   name: "PNG",
    //   src: "/assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-playngo",
    // },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "PG",
      name: "PG",
      src: "/assets/Platform/provider-awcv2_pg.png",
      alt: "provider-awcv2_pg",
    },

    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "RELAX",
      name: "RELAX",
      src: "/assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "HACKSAW",
      name: "HACKSAW",
      src: "/assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_hacksaw",
    },
  ],
  fishing: [
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "JILI",
      name: "JILI",
      src: "/assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "JDB",
      name: "JDB",
      src: "/assets/Platform/jdb.png?v=1770791064378",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "FC",
      name: "FC",
      src: "/assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },

    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "FASTSPIN",
      name: "FASTSPIN",
      src: "/assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmfastspin",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "SPADE",
      name: "SPADE",
      src: "/assets/Platform/provider-awcmsg.png",
      alt: "provider-awcmsg",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "YESBINGO",
      name: "YELLOW BAT",
      src: "/assets/Platform/provider-awcv2_yesbingo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yesbingo",
    },

    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "ACEWIN",
      name: "ACEWiN",
      src: "/assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_acewin",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "JJ",
      name: "JJ",
      src: "/assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_jj",
    },
  ],
  arcade: [
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "JDB",
      name: "JDB",
      src: "/assets/Platform/jdb.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "FC",
      name: "FC",
      src: "/assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },

    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "PP",
      name: "PP",
      src: "/assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },

    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "JILI",
      name: "JILI",
      src: "/assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "PG",
      name: "PG",
      src: "/assets/Platform/provider-awcv2_pg.png",
      alt: "provider-awcv2_pg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "KINGMAKER",
      name: "KM",
      src: "/assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },

    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "CG",
      name: "CG",
      src: "/assets/Platform/provider-awcmcg.png",
      alt: "provider-awcmcg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "YL",
      name: "YL",
      src: "/assets/Platform/darkIcon.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "RELAX",
      name: "RELAX",
      src: "/assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
  ],
  lottery: [
    {
      categoryType: "VENDOR",
      gameType: 64,
      vendor: "JILI",
      name: "JILI",
      src: "/assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 64,
      vendor: "KINGMAKER",
      name: "KM",
      src: "/assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },
    {
      categoryType: "VENDOR",
      gameType: 64,
      vendor: "YESBINGO",
      name: "YELLOW BAT",
      src: "/assets/Platform/provider-awcv2_yesbingo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yesbingo",
    },
  ],
};
export const HomeFooterPlatform = [
  {
    name: "saba",
    image: "/assets/Footer/provider-saba.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "jdb",
    image: "/assets/Footer/provider-jdb.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "jdbaspribe",
    image:
      "/assets/Footer/provider-jdbaspribe.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "cq9",
    image: "/assets/Footer/provider-cq9.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "pg",
    image: "/assets/Footer/provider-pg.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "evo",
    image: "/assets/Footer/provider-evo.webp?v=1772072361392&source=mcdsrc",
  },

  {
    name: "netent",
    image: "/assets/Footer/provider-netent.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "png",
    image: "/assets/Footer/provider-png.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "rich88",
    image: "/assets/Footer/provider-rich88.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "worldmatch",
    image:
      "/assets/Footer/provider-worldmatch.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmsexy",
    image:
      "/assets/Footer/provider-awcmsexy.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmrt",
    image: "/assets/Footer/provider-awcmrt.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmsg",
    image: "/assets/Footer/provider-awcmsg.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmkm",
    image: "/assets/Footer/provider-awcmkm.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmjili",
    image:
      "/assets/Footer/provider-awcmjili.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmp8",
    image: "/assets/Footer/provider-awcmp8.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmfc",
    image: "/assets/Footer/provider-awcmfc.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmhotroad",
    image:
      "/assets/Footer/provider-awcmhotroad.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmpp",
    image: "/assets/Footer/provider-awcmpp.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmpt",
    image: "/assets/Footer/provider-awcmpt.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "horsebook",
    image: "/assets/Footer/icon-horsebook.svg?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmfastspin",
    image:
      "/assets/Footer/provider-awcmfastspin.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmyesbingo",
    image:
      "/assets/Footer/provider-awcmyesbingo.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "sv388",
    image: "/assets/Footer/icon-sv388.svg?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcme1sport",
    image:
      "/assets/Footer/provider-awcme1sport.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmrwb",
    image: "/assets/Footer/provider-awcmrwb.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmpinnacle",
    image:
      "/assets/Footer/provider-awcmpinnacle.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "nst",
    image: "/assets/Footer/icon-nst.svg?v=1772072361392&source=mcdsrc",
  },
];
export const HomeFavourite = [
  {
    name: "Lucky Jaguar 500",
    image: "/assets/HotGames/JILI-SLOT-160.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-115",
  },
  {
    gameType: "SLOT",
    casinoType: "PP-SLOT-612",
    platFormCode: "PP",
    name: "Big Bass Christmas - Frozen Lake",
    image: "/assets/HotGames/PP-SLOT-612.Big Bass Christmas - Frozen Lake.webp",
  },
  {
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-142",
    name: "Super Ace Speed Exclusive",
    image: "/assets/HotGames/JILI-SLOT-151.webp",
  },
  {
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-043",
    name: "Fortune Gems 500",
    image: "/assets/HotGames/JILI-SLOT-138.webp",
  },
  {
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-102",
    name: "Super Ace Deluxe",
    image: "/assets/HotGames/JILI-SLOT-102.webp",
  },
  {
    gameType: "SLOT",
    casinoType: "PP-SLOT-602",
    platFormCode: "PP",
    name: "Mermaid's Treasure Trove",
    image: "/assets/HotGames/PP-SLOT-602.Mermaid_s Treasure Trove.webp",
  },
];
export const Favourite = [
  {
    gameType: 8192,
    vendorCode: "JILI",
    name: "Aviator",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
    src: "/assets/HotGames/aviator.webp",
  },
  {
    gameType: 2,
    vendorCode: "EVOLUTION",
    name: "Crazy Time",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
    src: "/assets/HotGames/darkIcon (19).webp",
  },
  {
    vendorCode: "JILI",
    name: "Super Ace",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
    src: "/assets/HotGames/darkIcon (12).webp",
  },
  {
    vendorCode: "JILI",
    name: "Money Coming",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-029",
    src: "/assets/HotGames/darkIcon (8).webp",
  },
  {
    src: "/assets/HotGames/JILI-SLOT-043.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-043",
    name: "Fortune Gems",
  },

  {
    id: 2,
    src: "/assets/images/jdb.png",
    name: "JDB",
    titlebn: "জেডিবি",
    key: "SLOT",
    gameType: "SLOT",
    platFormCode: "JDB",
    casinoType: "",
  },
  {
    id: 3,
    src: "/assets/images/jilli.webp",
    name: "JILI",
    titlebn: "ঝিলি",
    key: "SLOT",
    gameType: "SLOT",
    platFormCode: "JILI",
    casinoType: "",
  },
  {
    id: 4,
    src: "/assets/images/pp.webp",
    name: "PP",
    titlebn: "প্যারাগমেটিক প্লে",
    key: "SLOT",
    gameType: "SLOT",
    platFormCode: "PP",
    casinoType: "",
  },
  {
    id: 5,
    src: "/assets/images/spade.png",
    name: "SPADE",
    titlebn: "স্পেডি",
    key: "SLOT",
    gameType: "SLOT",
    platFormCode: "SPADE",
    casinoType: "",
  },
  {
    id: 6,
    src: "/assets/images/evolution.webp",
    name: "EVO",
    titlebn: "এভোলেশন",
    key: "LIVE",
    gameType: "LIVE",
    platFormCode: "EVOLUTION",
    casinoType: "",
  },
];
export const filtercasion = [
  {
    name: "PLAYTECH",
    image: "/assets/Platform/provider-awcmpt.png",
  },
  {
    name: "VIACASINO",
    image: "/assets/Platform/provider-awcmvia.png",
  },
  {
    name: "PP",
    image: "/assets/Platform/provider-awcmpp.png",
  },
  {
    name: "BG",
    image: "/assets/Platform/provider-bg.png",
  },
  {
    name: "EVOLUTION",
    image: "/assets/Platform/provider-evo.png",
  },
  {
    name: "SEXYBCRT",
    image: "/assets/Platform/provider-awcmsexy.png",
  },
  {
    name: "HOTROAD",
    image: "/assets/Platform/provider-awcmhotroad.png",
  },
  {
    name: "DREAMGAMING",
    image: "/assets/Platform/provider-awcmdg.png",
  },
  {
    name: "CREEDROOMZ",
    image: "/assets/Platform/provider-awcv2_creedroomz.png",
  },
  {
    name: "WINFINITY",
    image: "/assets/Platform/provider-awcv2_winfinity.png",
  },
];

export const filterslot = [
  {
    name: "PG",
    image: "/assets/Platform/provider-awcv2_pg.png",
  },
  {
    name: "CG",
    image: "/assets/Platform/provider-awcmcg.png",
  },

  {
    name: "DRAGOONSOFT",
    image: "/assets/Platform/provider-dragoonsoft.png",
  },
  {
    name: "PP",
    image: "/assets/Platform/provider-awcmpp.png",
  },
  {
    name: "PLAYTECH",
    image: "/assets/Platform/provider-awcmpt.png",
  },
  {
    name: "KINGMAKER",
    image: "/assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "RT",
    image: "/assets/Platform/provider-awcmrt.png",
  },
  {
    name: "BTG",
    image:
      "/assets/Platform/provider-awcv2_btg.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JILI",
    image: "/assets/Platform/provider-awcmjili.png",
  },
  {
    name: "NETENT",
    image: "/assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JDB",
    image: "/assets/Platform/provider-jdb.png",
  },
  {
    name: "FC",
    image: "/assets/Platform/provider-awcmfc.png",
  },
  {
    name: "NLC",
    image: "/assets/Platform/provider-nlc.png",
  },
  {
    name: "FASTSPIN",
    image: "/assets/Platform/provider-awcmfastspin.png",
  },
  {
    name: "YGGDRASIL",
    image:
      "/assets/Platform/provider-awcv2_yggdrasil.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "SPADE",
    image: "/assets/Platform/provider-awcmsg.png",
  },
  {
    name: "JJ",
    image:
      "/assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "Joker",
    image: "/assets/Platform/provider-joker.png",
  },
  {
    name: "OCTOPLAY",
    image: "/assets/Platform/provider-awcv2_octoplay.png",
  },
  {
    name: "PLAYNGO",
    image:
      "/assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  },

  {
    name: "ACEWIN",
    image:
      "/assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "PLAY8",
    image: "/assets/Platform/provider-awcmp8.png",
  },
  {
    name: "RELAX",
    image:
      "/assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "YESBINGO",
    image: "/assets/Platform/provider-awcmyesbingo.png",
  },
  {
    name: "YL",
    image: "/assets/Platform/yl.png",
  },
];

export const filtertable = [
  {
    image: "/assets/Platform/provider-awcmjili.png",
    name: "JILI",
  },
  {
    name: "HACKSAW",
    image:
      "/assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
  },
  {
    image: "/assets/Platform/provider-awcmkm.png",
    name: "KINGMAKER",
  },
  {
    name: "NETENT",
    image: "/assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "PLAYTECH",
    image: "/assets/Platform/provider-awcmpt.png",
  },
  // {
  //   name: "PLAYNGO",
  //   image:
  //     "/assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  // },
  {
    name: "RELAX",
    image:
      "/assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   image: "/assets/Platform/provider-rich88.png",
  //   name: "RICH88",
  // },
  {
    name: "PG",
    image: "/assets/Platform/provider-awcv2_pg.png",
  },
  {
    image: "/assets/Platform/provider-jdbaspribe.png",
    name: "SPRIBE",
  },
];

export const filtercrash = [
  {
    image: "/assets/Platform/provider-jdbaspribe.png",
    name: "SPRIBE",
  },
  {
    name: "JDB",
    image: "/assets/Platform/provider-jdb.png",
  },
  {
    name: "YL",
    image: "/assets/Platform/yl.png",
  },
  {
    name: "RELAX",
    image:
      "/assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  {
    image: "/assets/Platform/provider-awcmjili.png",
    name: "JILI",
  },
  {
    name: "PP",
    image: "/assets/Platform/provider-awcmpp.png",
  },
  {
    name: "CG",
    image: "/assets/Platform/provider-awcmcg.png",
  },
  // {
  //   image: "/assets/Platform/provider-rich88.png",
  //   name: "RICH88",
  // },
  // {
  //   name: "Joker",
  //   image: "/assets/Platform/provider-joker.png",
  // },
  // {
  //   name: "SMARTSOFT",
  //   image:
  //     "/assets/Platform/provider-awcv2_smartsoft.png?v=1772072361392&source=mcdsrc",
  // },
  {
    image: "/assets/Platform/provider-awcmkm.png",
    name: "KINGMAKER",
  },
  // {
  //   name: "PLAYNGO",
  //   image:
  //     "/assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  // },
  {
    image: "/assets/Platform/provider-awcmfc.png",
    name: "FC",
  },
  {
    image:
      "/assets/Platform/provider-awcv2_crash88.png?v=1772072361392&source=mcdsrc",
    name: "CRASH88",
  },
];

export const filterfishing = [
  {
    name: "JILI",
    image: "/assets/Platform/provider-awcmjili.png",
  },
  {
    name: "SPADE",
    image: "/assets/Platform/provider-awcmsg.png",
  },
  {
    name: "FC",
    image: "/assets/Platform/provider-awcmfc.png",
  },
  {
    name: "YESBINGO",
    image: "/assets/Platform/provider-awcmyesbingo.png",
  },
  {
    name: "ACEWIN",
    image:
      "/assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JDB",
    image: "/assets/Platform/provider-jdb.png",
  },
  {
    name: "FASTSPIN",
    image:
      "/assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JJ",
    image:
      "/assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   name: "JOKER",
  //   image: "/assets/Platform/provider-joker.png",
  // },
  // {
  //   name: "GTF",
  //   image:
  //     "/assets/Platform/provider-awcv2_gtf.png?v=1772072361392&source=mcdsrc",
  // },
];

export const filterarcade = [
  {
    image: "/assets/Platform/provider-awcv2_pg.png",
    name: "PG",
  },
  {
    name: "JILI",
    image: "/assets/Platform/provider-awcmjili.png",
  },
  {
    name: "PP",
    image: "/assets/Platform/provider-awcmpp.png",
  },
  {
    name: "KINGMAKER",
    image: "/assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "CG",
    image: "/assets/Platform/provider-awcmcg.png",
  },
  {
    image: "/assets/Platform/provider-jdb.png",
    name: "JDB",
  },
  {
    image: "/assets/Platform/provider-awcmfc.png",
    name: "FC",
  },
  // {
  //   name: "HACKSAW",
  //   image:
  //     "/assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
  // },
  {
    image: "/assets/Platform/provider-awcmyl.png",
    name: "YL",
  },
  {
    name: "RELAX",
    image:
      "/assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   image: "/assets/Platform/provider-rich88.png",
  //   name: "RICH88",
  // },
];

export const filterlotto = [
  {
    image: "/assets/Platform/provider-awcmjili.png",
    name: "JILI",
  },

  {
    name: "YESBINGO",
    image: "/assets/Platform/provider-awcmyesbingo.png",
  },
  {
    name: "KINGMAKER",
    image: "/assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   name: "PLAYNGO",
  //   image:
  //     "/assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  // },
  // {
  //   name: "HACKSAW",
  //   image:
  //     "/assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
  // },
  // {
  //   name: "Joker",
  //   image: "/assets/Platform/provider-joker.png",
  // },
  // {
  //   name: "RICH88",
  //   image: "/assets/Platform/provider-rich88.png",
  // },
];
export const AllCasinoPlatform = [
  {
    name: "PLAYTECH",
    image: "/assets/Platform/provider-awcmpt.png",
  },
  {
    name: "VIACASINO",
    image: "/assets/Platform/provider-awcmvia.png",
  },
  {
    name: "PP",
    image: "/assets/Platform/provider-awcmpp.png",
  },
  {
    name: "BG",
    image: "/assets/Platform/provider-bg.png",
  },
  {
    name: "EVOLUTION",
    image: "/assets/Platform/provider-evo.png",
  },
  {
    name: "SEXYBCRT",
    image: "/assets/Platform/provider-awcmsexy.png",
  },
  {
    name: "HOTROAD",
    image: "/assets/Platform/provider-awcmhotroad.png",
  },
  {
    name: "DREAMGAMING",
    image: "/assets/Platform/provider-awcmdg.png",
  },
  {
    name: "CREEDROOMZ",
    image: "/assets/Platform/provider-awcv2_creedroomz.png",
  },
  {
    name: "WINFINITY",
    image: "/assets/Platform/provider-awcv2_winfinity.png",
  },
  {
    image: "/assets/Platform/provider-awcv2_pg.png",
    name: "PG",
  },
  {
    name: "CG",
    image: "/assets/Platform/provider-awcmcg.png",
  },
  {
    name: "DRAGOONSOFT",
    image: "/assets/Platform/provider-dragoonsoft.png",
  },
  {
    name: "KINGMAKER",
    image: "/assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "RT",
    image: "/assets/Platform/provider-awcmrt.png",
  },
  {
    name: "BTG",
    image:
      "/assets/Platform/provider-awcv2_btg.png?v=1772072361392&source=mcdsrc",
  },
  {
    image: "/assets/Platform/provider-awcmjili.png",
    name: "JILI",
  },
  {
    name: "NETENT",
    image: "/assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JDB",
    image: "/assets/Platform/provider-jdb.png",
  },
  {
    name: "FC",
    image: "/assets/Platform/provider-awcmfc.png",
  },
  {
    name: "NLC",
    image: "/assets/Platform/provider-nlc.png",
  },
  {
    name: "FASTSPIN",
    image:
      "/assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "YGGDRASIL",
    image:
      "/assets/Platform/provider-awcv2_yggdrasil.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "SPADE",
    image: "/assets/Platform/provider-awcmsg.png",
  },
  {
    name: "JJ",
    image:
      "/assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "Joker",
    image: "/assets/Platform/provider-joker.png",
  },
  {
    name: "OCTOPLAY",
    image: "/assets/Platform/provider-awcv2_octoplay.png",
  },
  {
    name: "PLAYNGO",
    image:
      "/assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "ACEWIN",
    image:
      "/assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "PLAY8",
    image: "/assets/Platform/provider-awcmp8.png",
  },
  {
    name: "RELAX",
    image:
      "/assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "YESBINGO",
    image: "/assets/Platform/provider-awcmyesbingo.png",
  },
  {
    image: "/assets/Platform/provider-awcmyl.png",
    name: "YL",
  },
  {
    name: "HACKSAW",
    image:
      "/assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
  },
  {
    image: "/assets/Platform/provider-jdbaspribe.png",
    name: "SPRIBE",
  },
  {
    image:
      "/assets/Platform/provider-awcv2_crash88.png?v=1772072361392&source=mcdsrc",
    name: "CRASH88",
  },
];
export const HomeIcon = {
  sports: `../assets/Icon/icon-sport.png`,
  casino: "../assets/Icon/icon-casino.png",
  slots: "../assets/Icon/icon-slot.png",
  table: "../assets/Icon/icon-table.png",
  crash: "../assets/Icon/icon-crash.png",
  fishing: "../assets/Icon/icon-fish.png",
  arcade: "../assets/Icon/icon-arcade.png",
  lotto: "../assets/Icon/icon-lottery.png",
};
